import LegacyBigRoundButton from './LegacyBigRoundButton';

export * from './LegacyBigRoundButton';

export default LegacyBigRoundButton;
